import React, { Component, createRef } from "react";
import {
  DEFAULT_VALUES,
  ENDPOINT_DATA_TYPES,
  DATA_SOURCES,
  SERVERS,
  LAYER_TEMPLET,
} from "../config";
import {
  Select,
  MenuItem,
  Stack,
  TextField,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";

const toggle_values = [
  {
    key: ENDPOINT_DATA_TYPES.USMS,
    value: ENDPOINT_DATA_TYPES.USMS,
  },
  {
    key: ENDPOINT_DATA_TYPES.UNSTRUCTURED,
    value: ENDPOINT_DATA_TYPES.UNSTRUCTURED,
  },
];

class MapDataComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDuplicateLayerError: false,
    };
    this.initFields();
    this.setValues(null);
  }

  initFields() {
    this.refsMap = {
      s3Account: createRef(),
      s3Bucket: createRef(),
      s3FilePath: createRef(),
      adlsContainer: createRef(),
      adlsFilepath: createRef(),
      unityCatalogCatalog: createRef(),
      unityCatalogSchema: createRef(),
      unityCatalogTable: createRef(),
      unityCatalogDiffCol: createRef(),
      unityCatalogDiffVal: createRef(),
      usmsFilePath: createRef(),
      usmsFeature: createRef(),
      usmsLayer: createRef(),
      geometryCol: createRef(),
    };
  }

  componentDidMount() {
    this.setValues(null);
  }

  componentDidUpdate(prevProps) {
    const layerId = this.props.layerId;
    const layer = this.props.layers[layerId];
    if (
      (prevProps.layers[prevProps.layerId].dataSource !== layer.dataSource &&
        layer.dataSource !== undefined) ||
      (prevProps.layers[prevProps.layerId].dataEndpoint !==
        layer.dataEndpoint &&
        layer.dataEndpoint !== undefined)
    ) {
      this.setValues(null);
    }
  }

  setValues(layerPayload) {
    const layer = layerPayload !== null ? layerPayload : this.props.layers[this.props.layerId];
    const { refsMap } = this;

    const setRefValue = (ref, value, defaultValue) => {
      if (ref.current) {
        ref.current.value = value || defaultValue;
      }
    };

    const setUnstructuredValues = (layer) => {
      if (layer.dataSource === DATA_SOURCES.S3) {
        setRefValue(refsMap.s3Account, layer.s3Account, DEFAULT_VALUES.s3DefaultAccount);
        setRefValue(refsMap.s3Bucket, layer.s3Bucket, DEFAULT_VALUES.s3DefaultBucket);
        setRefValue(refsMap.s3FilePath, layer.s3FilePath, DEFAULT_VALUES.unstucturedS3DefaultFilePath);
      } else if (layer.dataSource === DATA_SOURCES.ADLS) {
        setRefValue(refsMap.adlsContainer, layer.adlsContainer, DEFAULT_VALUES.unstructuredADLSDefaultContainer);
        setRefValue(refsMap.adlsFilepath, layer.adlsFilepath, DEFAULT_VALUES.unstructuredADLSDefaultFilePath);
      } else if (layer.dataSource === DATA_SOURCES.UNITY_CATALOG) {
        setRefValue(refsMap.unityCatalogCatalog, layer.unityCatalogCatalog, DEFAULT_VALUES.unstructuredUCDefaultCatalog);
        setRefValue(refsMap.unityCatalogSchema, layer.unityCatalogSchema, DEFAULT_VALUES.unstructuredUCDefaultSchema);
        setRefValue(refsMap.unityCatalogTable, layer.unityCatalogTable, DEFAULT_VALUES.unstructuredUCDefaultTable);
        setRefValue(refsMap.unityCatalogDiffCol, layer.unityCatalogDiffCol, DEFAULT_VALUES.unstructuredUCDefaultDiffCol);
        setRefValue(refsMap.unityCatalogDiffVal, layer.unityCatalogDiffVal, DEFAULT_VALUES.unstructuredUCDefaultDiffVal);
      }
      setRefValue(refsMap.geometryCol, layer.geometryCol, DEFAULT_VALUES.defaultGeometryCol);
    };

    const setUsmsValues = (layer) => {
      setRefValue(refsMap.s3Account, layer.s3Account, DEFAULT_VALUES.s3DefaultAccount);
      setRefValue(refsMap.s3Bucket, layer.s3Bucket, DEFAULT_VALUES.s3DefaultBucket);
      setRefValue(refsMap.usmsFilePath, layer.usmsFilePath, DEFAULT_VALUES.usmsDefaultFilePath);
      setRefValue(refsMap.usmsFeature, layer.usmsFeature, DEFAULT_VALUES.usmsDefaultFeature);
      setRefValue(refsMap.usmsLayer, layer.usmsLayer, DEFAULT_VALUES.usmsDefaultLayer);
      setRefValue(refsMap.geometryCol, layer.geometryCol, DEFAULT_VALUES.defaultGeometryCol);
    };

    if (layer.dataEndpoint === ENDPOINT_DATA_TYPES.UNSTRUCTURED) {
      setUnstructuredValues(layer);
    } else if (layer.dataEndpoint === ENDPOINT_DATA_TYPES.USMS) {
      setUsmsValues(layer);
    }
  }

  handleDataSourceChange = (event) => {
    const newDataSource = event.target.value;
    const { layers, layerId, setLayers } = this.props;
    const layer = layers[layerId];
    setLayers((prevLayers) => ({
      ...prevLayers,
      [layerId]: {
        ...layer,
        dataSource: newDataSource,
      },
    }));
  };

  handleDataEndpointChange = (event) => {
    const newDataEndpoint = event.target.value;
    const { layers, layerId, setLayers } = this.props;
    const layer = layers[layerId];
    setLayers((prevLayers) => ({
      ...prevLayers,
      [layerId]: {
        ...layer,
        dataEndpoint: newDataEndpoint,
      },
    }));
  };

  handleMapDataChange = () => {
    const { layers, setLayers, layerId } = this.props;
    const layer = layers[layerId];

    const updatedLayer = {
      ...LAYER_TEMPLET,
      id: layer.id,
      name: layer.name,
      color: layer.color,
      dataEndpoint: layer.dataEndpoint,
      dataSource: layer.dataSource,
      isNewLayer: false,
    };
  
    const setServerInput = (server) => {
      updatedLayer.serverInput = server;
    };
  
    const setS3Fields = () => {
      updatedLayer.s3Account = this.refsMap.s3Account.current.value || "";
      updatedLayer.s3Bucket = this.refsMap.s3Bucket.current.value || "";
      updatedLayer.s3FilePath = this.refsMap.s3FilePath.current.value || "";
    };
  
    const setADLSFields = () => {
      updatedLayer.adlsContainer = this.refsMap.adlsContainer.current.value || "";
      updatedLayer.adlsFilepath = this.refsMap.adlsFilepath.current.value || "";
    };
  
    const setUnityCatalogFields = () => {
      updatedLayer.unityCatalogCatalog = this.refsMap.unityCatalogCatalog.current.value || "";
      updatedLayer.unityCatalogSchema = this.refsMap.unityCatalogSchema.current.value || "";
      updatedLayer.unityCatalogTable = this.refsMap.unityCatalogTable.current.value || "";
      updatedLayer.unityCatalogDiffCol = this.refsMap.unityCatalogDiffCol.current.value || "";
      updatedLayer.unityCatalogDiffVal = this.refsMap.unityCatalogDiffVal.current.value || "";
    };
  
    if (updatedLayer.dataEndpoint === ENDPOINT_DATA_TYPES.UNSTRUCTURED) {
      switch (updatedLayer.dataSource) {
        case DATA_SOURCES.S3:
          setServerInput(SERVERS.S3_SERVER);
          setS3Fields();
          break;
        case DATA_SOURCES.ADLS:
          setServerInput(SERVERS.ADLS_SERVER);
          setADLSFields();
          break;
        case DATA_SOURCES.UNITY_CATALOG:
          setServerInput(SERVERS.UC_SERVER);
          setUnityCatalogFields();
          break;
        default:
          break;
      }
    } else {
      setServerInput(SERVERS.S3_SERVER);
      updatedLayer.s3Account = this.refsMap.s3Account.current.value || "";
      updatedLayer.s3Bucket = this.refsMap.s3Bucket.current.value || "";
      updatedLayer.usmsFilePath = this.refsMap.usmsFilePath.current.value || "";
      updatedLayer.usmsFeature = this.refsMap.usmsFeature.current.value || "";
      updatedLayer.usmsLayer = this.refsMap.usmsLayer.current.value || "";
    }

    updatedLayer.geometryCol = this.refsMap.geometryCol.current.value || "";

    setLayers((prevLayer) => ({
      ...prevLayer,
      [layerId]: updatedLayer,
    }));
    this.props.handleUpdateButtonClick(updatedLayer);
  };

  isDuplicateLayerConfig = (newLayer, existingLayers) => {
    const { refsMap } = this;

    return Object.entries(existingLayers).some(([layerId, layer]) => {
      if (
        newLayer.dataEndpoint === layer.dataEndpoint &&
        newLayer.dataSource === layer.dataSource &&
        layerId !== this.props.layerId
      ) {
        switch (newLayer.dataSource) {
          case DATA_SOURCES.S3:
            return (
              newLayer.s3Account === refsMap.s3Account.current.value &&
              newLayer.s3Bucket === refsMap.s3Bucket.current.value &&
              newLayer.s3FilePath === refsMap.s3FilePath.current.value &&
              newLayer.geometryCol === refsMap.geometryCol.current.value
            );
          case DATA_SOURCES.ADLS:
            return (
              newLayer.adlsContainer === refsMap.adlsContainer.current.value &&
              newLayer.adlsFilepath === refsMap.adlsFilepath.current.value &&
              newLayer.geometryCol === refsMap.geometryCol.current.value
            );
          case DATA_SOURCES.UNITY_CATALOG:
            return (
              newLayer.unityCatalogCatalog ===
                refsMap.unityCatalogCatalog.current.value &&
              newLayer.unityCatalogSchema ===
                refsMap.unityCatalogSchema.current.value &&
              newLayer.unityCatalogTable ===
                refsMap.unityCatalogTable.current.value &&
              newLayer.unityCatalogDiffCol ===
                refsMap.unityCatalogDiffCol.current.value &&
              newLayer.unityCatalogDiffVal ===
                refsMap.unityCatalogDiffVal.current.value &&
              newLayer.geometryCol === refsMap.geometryCol.current.value
            );
          case ENDPOINT_DATA_TYPES.USMS:
            return (
              newLayer.s3Account === refsMap.s3Account.current.value &&
              newLayer.s3Bucket === refsMap.s3Bucket.current.value &&
              newLayer.usmsFilePath === refsMap.usmsFilePath.current.value &&
              newLayer.usmsFeature === refsMap.usmsFeature.current.value &&
              newLayer.usmsLayer === refsMap.usmsLayer.current.value &&
              newLayer.geometryCol === refsMap.geometryCol.current.value
            );
          default:
            return false;
        }
      }
      return false;
    });
  };

  handleMapDataSave = () => {
    if (
      this.isDuplicateLayerConfig(
        this.props.layers[this.props.layerId],
        this.props.layers
      )
    ) {
      this.setState({
        isDuplicateLayerError: true,
      });
      return;
    }
    this.handleMapDataChange();
    this.setState({ isDuplicateLayerError: false });
  };

  renderFields(fields) {
    return (
      <Stack spacing={2}>
        {fields.map((field) => (
          <TextField
            key={field.label}
            inputRef={this.refsMap[field.key]}
            label={field.label}
          />
        ))}
        <Button
          onClick={
            this.props.layers[this.props.layerId].isNewLayer === true
              ? this.handleMapDataSave
              : this.handleMapDataChange
          }
        >
          {this.props.layers[this.props.layerId].isNewLayer === true
            ? "Save"
            : "Update"}
        </Button>
        {this.state.isDuplicateLayerError && (
          <Typography color="error">
            Layer configuration already exists. Please update the layer.
          </Typography>
        )}
      </Stack>
    );
  }

  render() {
    const layerId = this.props.layerId;
    const layer = this.props.layers[layerId];

    const fieldGroup = {
      S3: [
        { key: "s3Account", label: "s3 Account" },
        { key: "s3Bucket", label: "s3 Bucket" },
        { key: "s3FilePath", label: "s3 File Path" },
        {
          key: "geometryCol",
          label:
            "Geometry Column to render. If blank, lat/lon pair will be used if available",
        },
      ],
      ADLS: [
        { key: "adlsContainer", label: "ADLS Container" },
        { key: "adlsFilepath", label: "ADLS Filepath" },
        {
          key: "geometryCol",
          label:
            "Geometry Column to render. If blank, lat/lon pair will be used if available",
        },
      ],
      "Unity Catalog": [
        { key: "unityCatalogCatalog", label: "Unity Catalog Catalog" },
        { key: "unityCatalogSchema", label: "Unity Catalog Schema" },
        { key: "unityCatalogTable", label: "Unity Catalog Table" },
        {
          key: "unityCatalogDiffCol",
          label: "Optional: Unity Catalog Differentiator Column",
        },
        {
          key: "unityCatalogDiffVal",
          label: "Optional: Unity Catalog Differentiator Value",
        },
        {
          key: "geometryCol",
          label:
            "Geometry Column to render. If blank, lat/lon pair will be used if available",
        },
      ],
      USMS: [
        { key: "s3Account", label: "S3 Account" },
        { key: "s3Bucket", label: "S3 Bucket" },
        { key: "usmsFilePath", label: "USMS Job Id" },
        { key: "usmsFeature", label: "Feature" },
        { key: "usmsLayer", label: "Layer" },
        {
          key: "geometryCol",
          label:
            "Geometry Column to render. If blank, lat/lon pair will be used if available",
        },
      ],
    };

    return (
      <div>
        <div>
          <ToggleButtonGroup
            color="primary"
            exclusive
            value={layer.dataEndpoint}
            onChange={this.handleDataEndpointChange}
          >
            {toggle_values.map((item) => (
              <ToggleButton key={item.key} value={item.key}>
                {item.value}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </div>
        {layer.dataEndpoint === "Unstructured" ? (
          <div>
            <h5>Select Data Source</h5>
            <Select
              value={layer.dataSource}
              onChange={this.handleDataSourceChange}
              label="Data Source"
              labelId="Data Source Selector"
              style={{ marginBottom: "20px" }}
            >
              <MenuItem value={DATA_SOURCES.S3}>S3 (dev)</MenuItem>
              <MenuItem value={DATA_SOURCES.ADLS}>
                ADLS (124381d1stadls)
              </MenuItem>
              <MenuItem value={DATA_SOURCES.UNITY_CATALOG}>
                Unity Catalog (124381d1)
              </MenuItem>
            </Select>
            {this.renderFields(fieldGroup[layer.dataSource])}
          </div>
        ) : (
          <div>
            <h5>USMS</h5>
            {this.renderFields(fieldGroup[ENDPOINT_DATA_TYPES.USMS])}
          </div>
        )}
      </div>
    );
  }
}

export default MapDataComponent;
